const state = {
  // globalBaseUrl: 'https://home-store-img.uniontech.com/'
  globalBaseUrl: process.env.VUE_APP_CDN_DOMAIN,
}

const mutations = {
  setGlobalBaseUrl(state, payload) {
    state.globalBaseUrl = payload
  },
}

const actions = {
  updateGlobalBaseUrl({ commit }, payload) {
    commit('setGlobalBaseUrl', payload)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
